module.exports = __webpack_public_path__ + "img/LogoLight.e5c1bcb1.svg";